"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBrowserOnlyLayoutEffect = void 0;
const react_1 = require("react");
const isBrowser = typeof window !== 'undefined' &&
    typeof window.document !== 'undefined' &&
    typeof window.document.createElement !== 'undefined';
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
const useIsomorphicLayoutEffect = isBrowser
    ? react_1.useLayoutEffect
    : react_1.useEffect;
function noop() {
    /* no-op */
}
function useBrowserOnlyLayoutEffect(effect, deps) {
    useIsomorphicLayoutEffect(isBrowser ? effect : noop, deps);
}
exports.useBrowserOnlyLayoutEffect = useBrowserOnlyLayoutEffect;
exports.default = useIsomorphicLayoutEffect;
//# sourceMappingURL=useIsomorphicLayoutEffect.js.map